import React from "react";
import { CalendarCheckIcon, ClipboardListIcon, SearchIcon, ShieldCheckIcon, TargetIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { pathwaySteps } from "../data/content";
const icons = [ClipboardListIcon, SearchIcon, ShieldCheckIcon, TargetIcon, CalendarCheckIcon];
export function Pathway() {
  return <section className="bg-brand-950 px-5 py-16 text-white md:px-8 md:py-24" data-id="element-264" data-mp="37am1fqvsmi5c">
      <div className="mx-auto max-w-6xl" data-id="element-265" data-mp="3m00bz2b3v5mb">
        <p className="text-center text-sm font-bold text-gold-300" data-id="element-266" data-mp="3m2wcmyec88eg">Introducing the Perimenopause Decision Pathway™</p>
        <h2 className="mx-auto mt-3 max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight md:text-[2.6rem]" data-id="element-267" data-mp="3v1hsglsfd9bj">
          One practical framework. Five clinical decision stages.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-brand-200" data-id="element-268" data-mp="20n72ga03g946">
          I organized this resource around five connected stages that reflect the practical demands of
          perimenopause assessment.
        </p>

        <ol className="relative mt-12 grid gap-4 lg:grid-cols-5 lg:gap-3" data-id="element-269" data-mp="2ru92gk1cf15f">
          {pathwaySteps.map((s, i) => {
          const Icon = icons[i];
          return <li key={s.step} className="relative flex gap-4 rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10 lg:flex-col lg:p-6" data-id="element-270" data-mp="31qu9fawxambw" data-mpi={i}>
                <div className="flex shrink-0 flex-col items-center lg:flex-row lg:justify-between" data-id="element-271" data-mp="36j5aih3ege61">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold-400 text-brand-950" data-id="element-272" data-mp="3bgnncikjfdjb">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-273" data-mp="3fkd9l1dqpj16" />
                  </span>
                  <span className="mt-2 text-xs font-bold text-brand-200 lg:mt-0" data-id="element-274" data-mp="3kfipnjkgo3hc">Step {i + 1}</span>
                </div>
                <div data-id="element-275" data-mp="1q3klhw10dxsb">
                  <h3 className="text-xl font-extrabold" data-id="element-276" data-mp="1q4dt0z7skrbi">{s.step}</h3>
                  <p className="mt-2 text-base leading-relaxed text-brand-100" data-id="element-277" data-mp="1v2nq5fd2u1zr">{s.body}</p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg text-brand-100" data-id="element-278" data-mp="1n29ckz1xp18t">
          Five stages designed to turn scattered clinical information into one organized workflow.{" "}
          <span className="font-semibold text-white" data-id="element-279" data-mp="1x1qgbaxml525">The framework supports professional judgment rather than replacing it.</span>
        </p>

        <SectionCTA label="I want the 5-step decision pathway" tone="dark" data-id="element-280" data-mp="260txg9d8fae0" />
      </div>
    </section>;
}